import React from 'react';
import _isEqual from 'lodash/isEqual';
import _pickBy from 'lodash/pickBy';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

interface Props {
  value: { print: { enabled: boolean }; download: { enabled: boolean } };
  onChange: (key: string, value: any) => void;
}

function OrgChartExport({ value, onChange }: Props) {
  const classes = useStyles();
  const { print, download } = value;
  const printEnabled = print.enabled;
  const downloadEnabled = download.enabled;

  const handleToggleEnablePrintOrgChart = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.orgChart.print.enabled', e.target.checked);
  };

  const handleToggleEnableDownloadOrgChart = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.orgChart.download.enabled', e.target.checked);
  };

  return (
    <Card>
      <CardHeader
        title="Exporting"
        subheader="Configure how users will be able to export and download your org chart."
      />
      <Divider />
      <CardContent>
        <Typography variant="h6">Print</Typography>
        <div className={classes.content}>
          <Typography variant="subtitle2">
            Allow users to export a printable view of the org chart. The export will be of their
            current viewport.
          </Typography>
          <div>
            <Switch
              checked={printEnabled}
              inputProps={{ 'aria-label': 'print org chart switch' }}
              onChange={handleToggleEnablePrintOrgChart}
            />
          </div>
        </div>
        <Typography variant="h6">Download</Typography>
        <div className={classes.content}>
          <Typography variant="subtitle2">
            Allow users to download a fuller view. The export will include their entire expanded
            canvas.
          </Typography>
          <div>
            <Switch
              checked={downloadEnabled}
              inputProps={{ 'aria-label': 'download org chart switch' }}
              onChange={handleToggleEnableDownloadOrgChart}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default OrgChartExport;
